import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import SearchBar from '@app/components/SearchBar'
import { IContact } from '@app/models/Contact'
import {
  ICurrentUserState,
  impersonateActionCreators,
} from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Column } from 'react-virtualized'
import { Button } from 'reactstrap'
import { actionCreators, IUsersListState } from '../modules/userList'

interface IComponentRouterProps {
  id: string
}

type ComponentProps = IUsersListState &
  RouteComponentProps<IComponentRouterProps> &
  typeof actionCreators &
  ICurrentUserState &
  typeof impersonateActionCreators

export default class UsersListPage extends React.PureComponent<ComponentProps> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Users'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <div className='mb-2 d-flex flex-row justify-content-between'>
              <h3>Users</h3>
              <Link to='/admin/user/add' className='align-self-center'>
                <Button size='sm' color='primary'>
                  <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
                  <span>Add User</span>
                </Button>
              </Link>
            </div>
            <SearchBar
              onChange={this._onChangeFilter}
              placeholder='Looking for a certain user?'
              size='sm'
              value={this.props.filterText}
            />
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              loadItems={this.props.loadUsers}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  if (user.firstName) {
                    return `${user.firstName} ${user.lastName}`
                  } else {
                    return user.lastName
                  }
                }}
                dataKey='name'
                flexGrow={1}
                label='Name'
                width={200}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  return user.user ? user.user.username : ''
                }}
                dataKey='username'
                flexGrow={1}
                label='Username'
                width={200}
              />
              <Column
                cellDataGetter={({ rowData }) => {
                  const user = rowData as IContact
                  return user.user ? user.user.status : ''
                }}
                dataKey='status'
                label='Status'
                width={100}
              />
              {this.props.user &&
                this.props.user.status === 'System' &&
                this.props.user.permissions.isAdmin && (
                  <Column
                    cellRenderer={({ rowData }) => (
                      <Button
                        className='text-info'
                        color='link'
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          this.props.impersonateUser(rowData.id)
                        }}
                      >
                        <FontAwesomeIcon
                          icon={['fal', 'user-secret']}
                          fixedWidth
                        />
                      </Button>
                    )}
                    dataKey='id'
                    width={50}
                  />
                )}
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No users</div>
  }

  private _onRowClicked(item: IContact, index: number) {
    this.props.history.push(`/admin/user/${item.id}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
